import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import SurveyListItem from '../SurveyTable/SurveyListItem';
import './SuveyTableSection.css';

const SurveyTableSection = ({ title, surveys, instruction, completed }) => {
    if (surveys.length === 0) {
        return <Container></Container>;
    }
    return (
        <Container fluid>
            <Row>
                <Col className="h2">{title}</Col>
            </Row>
            <Row>
                <Col className="h6 text-muted mb-3">{instruction}</Col>
            </Row>
            <Row className="mt-3">
                <Col
                    md={{ span: 10, offset: 1 }}
                    xs={12}
                    className="background-section px-3 py-2"
                >
                    {surveys.map((s) => {
                        return (
                            <SurveyListItem
                                key={s.name}
                                name={s.name}
                                description={s.description}
                                id={s.id}
                                completed={completed}
                            />
                        );
                    })}
                </Col>
            </Row>
        </Container>
    );
};

export default SurveyTableSection;
